import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import SvgContainer from "src/components/SvgContainer";
import { getAppValue } from "src/utils/environment";
import { ReactComponent as DogStationIcon } from "./custom.svg";
import { ReactComponent as BabyIcon } from "./stroller.svg";

export default function OpenBabyStationButton({ ...rest }) {
  const { t } = useTranslation();
  return (
    <Button
      variant="containedSecondary"
      position="relative"
      // fontSize={["12px", "16px", "18px"]}
      fontSize="clamp(1.2rem, 2.29vmin, 1.8rem)"
      // px={["40px", "64px", "70px"]}
      px="7.6vmin"
      // py={["11px", "17px", "19px"]}
      py="2.1vmin"
      // borderRadius={["18px", "28px", "36px"]}
      borderRadius="3.4vmin"
      // minWidth={["208px", "290px", "312px"]}
      minWidth="40vmin"
      {...rest}
    >
      <SvgContainer
        position="absolute"
        top="50%"
        left={["16px", "18px", "20px"]}
        transform="translate(0%, -50%)"
        size="clamp(2rem, 3.816vmin, 3.2rem)"
        // width={["20px", "28px", "30px"]}
        // height={["20px", "28px", "30px"]}
        // size="20px"
        fill="white"
        icon={getAppValue({
          barkio: DogStationIcon,
          bibino: BabyIcon
        })}
      />
      {t("babyStation")}
    </Button>
  );
}
